//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';
import { NavTabs, PageFrameSidebar } from 'unison';

interface Props {
  children: React.ReactNode;
}

export const Sidebar = ({ children }: Props) => {
  return (
    <FullHeightPageFrameSidebar>
      <PageFrameSidebarContent>
        <FullHeightNavTabs direction='vertical'>{children}</FullHeightNavTabs>
      </PageFrameSidebarContent>
    </FullHeightPageFrameSidebar>
  );
};

const PageFrameSidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
`;

const FullHeightPageFrameSidebar = styled(PageFrameSidebar)`
  flex: 1;
`;

const FullHeightNavTabs = styled(NavTabs)`
  flex: 1;
`;

export default Sidebar;
